
import { LucideIcon } from 'lucide-react';
import { User, Mail, Lock, CreditCard, Truck, Calendar, Phone, FileText } from 'lucide-react';

// Helper function to get the appropriate icon for a field
export const getFieldIcon = (fieldName: string, fieldType: string): LucideIcon => {
  switch (fieldName) {
    case 'name': return User;
    case 'email': return Mail;
    case 'accountNumber': return CreditCard;
    case 'licenseNumber': return Truck;
    case 'password':
    case 'confirmPassword':
      return Lock;
    default:
      // Fallback based on type
      switch (fieldType) {
        case 'email': return Mail;
        case 'password': return Lock;
        case 'tel': return Phone;
        case 'date': return Calendar;
        default: return FileText;
      }
  }
};
